module.exports = __webpack_public_path__ + "img/arrowFull_right_gray.8fdf17e4.svg";